import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import Fa from 'react-fontawesome';
import {
  indexOf, filter, first, truncate,
  delay, throttle, startsWith, each,
} from 'lodash';
import { Navbar, Nav, NavItem, MenuItem, NavDropdown } from 'react-bootstrap';
import OrganizationSwitcher from '../OrganizationSwitcher/OrganizationSwitcher';
import Avatar from '../../../../components/avatar';
import { getWindowWidth, getEnvironment, getContainerWidth } from '../../AppReducer';

// Import Selectors
import { getUser, getIsSuperAdmin, getIsAdmin, getIsPIUser,
  getUserCurrentOrganization, getIsOrganizationManager,
  getCanSetupOrganization, getCollectorLanguageMappings,
} from '../../../Auth/AuthReducer';
import OrganizationResync from '../../../../components/organization-resync';
import { getCount } from '../../../News/NewsReducer';
import UISettingModal from './UiSettingModal';
import EmailAlertSubscriptionModal from './EmailAlertSubscriptionModal';

// Import Style
import styles from './Header.css';
import getMenus from './menu';

class Header extends Component {
  constructor() {
    super();
    this.state = {
      change: false,
      scrollUp: false,
      mouseEnter: false,
      showUISettings: false,
      showEmailSubscriptions: false,
      dropdownOpen: false,
    };
    this.handleScroll = throttle(this.handleScroll, 300).bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.scrollTop = 0;
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
      this.calculateNav();
    }
  }

  componentWillReceiveProps(nextProps) {
    const change = nextProps.notificationCount > this.props.notificationCount;
    this.setState({ change });
    delay(() => {
      this.setState({ change: false });
    }, 2000);
    if (this.props.containerWidth !== nextProps.containerWidth) {
      delay(() => {
        this.calculateNav();
      }, 1000);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  onMouseEnter() {
    if (typeof window !== 'undefined') {
      this.setState({ mouseEnter: true });
    }
  }

  onMouseLeave() {
    if (typeof window !== 'undefined') {
      const scrollTop = window.scrollY;
      this.setState({ mouseEnter: false, scrollUp: scrollTop === 0 });
    }
  }

  calculateNav() {
    if (this.navEl) {
      const { containerWidth } = this.props;
      const items = this.navEl.getElementsByClassName('menu-item');
      const collapseItem = this.navEl.getElementsByClassName('menu-item-collapse')[0];
      const collapseItemWidth = collapseItem ? collapseItem.offsetWidth : 0;
      const totalWidth = containerWidth - collapseItemWidth - 30;
      let currentWidth = 0;
      let totalHidden = 0;
      each(items, (item) => {
        item.removeAttribute('data-hidden');
        const w = item.offsetWidth;
        if (currentWidth + w < totalWidth) {
          currentWidth += w;
        } else {
          item.setAttribute('data-hidden', true);
          totalHidden += 1;
        }
      });
      if (collapseItem) {
        if (totalHidden === 0) {
          collapseItem.setAttribute('data-hidden', true);
        } else {
          collapseItem.removeAttribute('data-hidden');
        }
        const subItems = collapseItem.getElementsByClassName('sub-menu-item');
        const startIndex = subItems.length - totalHidden;
        each(subItems, (item, i) => {
          if (i < startIndex) {
            item.setAttribute('data-hidden', true);
          } else {
            item.removeAttribute('data-hidden');
          }
        });
      }
    }
  }

  isMobile() {
    return this.props.windowWidth < 768;
  }

  handleScroll() {
    if (typeof window !== 'undefined') {
      const scrollTop = window.scrollY;
      const scrolled = scrollTop - this.scrollTop;
      this.scrollTop = scrollTop;
      this.setState({ scrollUp: (scrolled < 0 || scrollTop === 0) });
    }
  }

  renderMenu() {
    const {
      user, location, isSuperAdmin, isAdmin,
      userCurrentOrganization, isOrganizationManager,
      notificationCount, canSetup,
    } = this.props;
    const { change, dropdownOpen } = this.state;

    const { pathname } = location;
    let active = false;
    if (pathname) {
      const root = first(filter(pathname.split('/')));
      active = root === 'admin' || root === 'setup';
    }
    let notification = null;
    if (notificationCount > 0) {
      const countComp = notificationCount < 10 ? notificationCount : '9+';
      const cls = change ? 'animated bounce' : '';
      notification = (
        <span style={{ display: 'inline-block' }} className={cls}>
          &nbsp;
          <span className="label label-danger">
            {countComp}
          </span>
        </span>
      );
    }
    const userName = truncate(user.display_name, { length: 20 });
    const userNameComp = (
      <span><Avatar user={user} size={24} className={styles.avatar} /> {userName}{notification}</span>
    );

    const items = [];
    if (dropdownOpen) {
      items.push({
        isComp: true,
        enabled: true,
        component: (
          <MenuItem key="org-name" header>
            <nobr>{userCurrentOrganization.display_name}:</nobr>
          </MenuItem>
        ),
      });

      items.push({
        route: '/setup',
        label: 'Organization Settings',
        icon: 'cogs',
        enabled: canSetup,
      });
      items.push({
        route: '/teams',
        enabled: isOrganizationManager || canSetup,
        label: 'My Teams',
        icon: 'users',
      });
      items.push({
        isComp: true,
        enabled: true,
        component: (
          <MenuItem key="email-alerts" onClick={(e) => { e.preventDefault(); this.setState({ showEmailSubscriptions: true }); }}>
            <nobr><Fa name="envelope" /> Email Alerts</nobr>
          </MenuItem>
        ),
      });
      /* User Settings */
      items.push({
        isComp: true,
        enabled: true,
        component: (
          <MenuItem key="universal-access" onClick={(e) => { e.preventDefault(); this.setState({ showUISettings: true }); }}>
            <nobr><Fa name="sliders" /> User Settings</nobr>
          </MenuItem>
        ),
      });
      if (userCurrentOrganization.manual_sync) {
        items.push({
          route: '/setup/organization/import',
          label: 'Import Data',
          icon: 'refresh',
          enabled: canSetup,
        });
      } else if (userCurrentOrganization.enabled === false) {
        items.push({
          isComp: true,
          enabled: true,
          component: (
            <MenuItem key="erefresh" disabled>
            <nobr><Fa name="refresh" /> Refresh Sync</nobr>
          </MenuItem>
          ),
        });
      } else {
        items.push({
          isComp: true,
          enabled: canSetup,
          component: (
            <OrganizationResync key="refresh" isMenu showConfirm={false} organization={userCurrentOrganization} btnTitle="Refresh Sync" />
          ),
        });
      }
      
     
      items.push({
        isComp: true,
        enabled: true,
        component: (
          <MenuItem key="divider-3" divider />
        ),
      });
      items.push({
        route: '/news',
        enabled: true,
        label: (
          <span>Announcements{notification}</span>
        ),
        icon: 'bell',
      });
      items.push({
        isComp: true,
        enabled: isSuperAdmin || isAdmin,
        component: (
          <MenuItem key="divider-4" divider />
        ),
      });

      items.push({
        route: '/admin',
        enabled: isSuperAdmin || isAdmin,
        label: 'Admin Control Panel',
        icon: 'wrench',
      });
      items.push({
        isComp: true,
        enabled: isSuperAdmin || isAdmin,
        component: (
          <MenuItem key="divider-5" divider />
        ),
      });
      items.push({
        route: '/logout',
        enabled: true,
        label: 'Sign out',
        icon: 'power-off',
      });
    }
    const k = `${user._id}|${userCurrentOrganization._id}`;

    return (
      <NavDropdown
        active={active}
        onToggle={(e) => { this.setState({ dropdownOpen: e }); }}
        title={userNameComp}
        id={k}
        key={k}
      >
        {items.map((item) => {
          if (!item.enabled) {
            return null;
          }
          if (item.isComp) {
            return item.component;
          }
          return (
            <LinkContainer key={item.route} to={item.route}>
              <NavItem><Fa name={item.icon} /> {item.label}</NavItem>
            </LinkContainer>
          );
        })}
      </NavDropdown>
    );
  }

  renderUserNav() {
    const {
      user, isSuperAdmin, isAdmin, isPIUser,
      userCurrentOrganization,
      location,
    } = this.props;
    let renderSwitch = (isSuperAdmin || isAdmin || isPIUser);
    // https://github.com/lumen-software/TruSales/issues/1011
    // apex page cannot use this
    const pathname = location.pathname || '';
    if (startsWith(pathname, '/apex/') || startsWith(pathname, '/request-feedback/')) {
      renderSwitch = false;
    }
    const isMobile = this.isMobile();
    if (user._id) {
      return (
        <Navbar.Collapse>
          {renderSwitch &&
            <Nav>
              <OrganizationSwitcher />
            </Nav>
          }
          {!renderSwitch &&
            <nav>
              <ul className="nav navbar-nav">
                <li className={styles.staticOrganizationName}><span>{(userCurrentOrganization.display_name || userCurrentOrganization.name)}</span></li>
              </ul>
            </nav>
          }
          {isMobile &&
            <nav>
              <ul className="nav navbar-nav">
                {this.renderSiteNav()}
              </ul>
            </nav>
          }
          {(user && user._id !== undefined && userCurrentOrganization && userCurrentOrganization._id !== undefined) && <Nav pullRight>{this.renderMenu()}</Nav>}
        </Navbar.Collapse>
      );
    }
    return null;
  }

  renderSiteNav() {
    const {
      user, userCurrentOrganization,
      canSeeAllPages,
    } = this.props;
    const isMobile = this.isMobile();
    const itemCls = isMobile ? '' : 'animated fadeInDown menu-item';
    const menus = getMenus(user, userCurrentOrganization, canSeeAllPages);
    if (menus && menus.length) {
      const items = menus.map(menu => (
        <LinkContainer key={menu.url} to={menu.url} className={itemCls}>
          <NavItem>{menu.label}</NavItem>
        </LinkContainer>
      ));
      if (!isMobile) {
        items.push((
          <NavDropdown pullRight key="collapse" title={(<Fa name="ellipsis-h" />)} className="menu-item-collapse" id="collapse-nav-dropdown">
            {menus.map(menu => (
              <LinkContainer key={menu.url} to={menu.url} className="sub-menu-item">
                <NavItem>{menu.label}</NavItem>
              </LinkContainer>
            ))}
          </NavDropdown>
        ));
      }
      return items;
    }
    return null;
  }

  render() {
    const { scrollUp, mouseEnter, showUISettings, showEmailSubscriptions } = this.state;
    const { user, userCurrentOrganization, environment } = this.props;
    const isMobile = this.isMobile();
    const isProduction = environment === 'production';
    const k = user && userCurrentOrganization ? `${user._id}|${userCurrentOrganization._id}` : '';
    return (
      <div
        id="app-header"
        key={k}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        className={`${styles.header} ${styles.headerCompact} ${(scrollUp || mouseEnter) ? '' : styles.headerCompactScroll}`}
        ref={(el) => { this.navEl = el; }}
      >
        <Navbar className={`${styles.headerNav} navbar-inverse animated fadeInDownBig`}>
          <Navbar.Header>
            <Navbar.Brand>
              <Link to="/"><img alt="logo" src="/assets/logo-white.png" role="presentation" className={styles.logo} /></Link>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          {!isProduction && environment !== null &&
            <Nav className="hidden-xs">
              <li style={{ paddingTop: '6px' }}><span className="text-uppercase label label-warning">{environment}</span></li>
            </Nav>
          }
          {this.props.user._id && this.renderUserNav()}
        </Navbar>
        {user !== null && user._id && !isMobile &&
          <Navbar className={`${styles.siteNav} animated fadeInDownBig`}>
            <Nav>
              {this.renderSiteNav()}
            </Nav>
          </Navbar>
        }
        <UISettingModal
          open={showUISettings}
          onClose={() => { this.setState({ showUISettings: false }); }}
        />
        <EmailAlertSubscriptionModal
          open={showEmailSubscriptions}
          onClose={() => { this.setState({ showEmailSubscriptions: false }); }}
        />
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const isAdmin = getIsAdmin(state);
  const isSuperAdmin = getIsSuperAdmin(state);
  const isPIUser = getIsPIUser(state);
  const userCurrentOrganization = getUserCurrentOrganization(state);
  const isOrganizationManager = getIsOrganizationManager(state);
  const user = getUser(state);
  let canSeeAllPages = false;
  if (isAdmin || isSuperAdmin) {
    canSeeAllPages = true;
  } else if (isPIUser && user && userCurrentOrganization && indexOf(user.organization__ids, userCurrentOrganization._id) >= 0) {
    canSeeAllPages = true;
  }
  return {
    user: getUser(state),
    isSuperAdmin,
    isAdmin,
    isPIUser,
    userCurrentOrganization,
    isOrganizationManager,
    notificationCount: getCount(state),
    canSeeAllPages,
    canSetup: getCanSetupOrganization(state),
    windowWidth: getWindowWidth(state),
    environment: getEnvironment(),
    languageMappings: getCollectorLanguageMappings(state),
    containerWidth: getContainerWidth(state),
  };
}

Header.propTypes = {
  user: PropTypes.shape({
    _id: PropTypes.string,
    display_name: PropTypes.string,
  }).isRequired,
  isSuperAdmin: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  isPIUser: PropTypes.bool.isRequired,
  isOrganizationManager: PropTypes.bool.isRequired,
  windowWidth: PropTypes.number,
  canSetup: PropTypes.bool,
  userCurrentOrganization: PropTypes.shape({
    _id: PropTypes.string,
    display_name: PropTypes.string,
    name: PropTypes.string,
    features: PropTypes.shape({
      feedback: PropTypes.bool,
      dashboard: PropTypes.bool,
      forecast: PropTypes.bool,
      outcomes: PropTypes.bool,
      performance: PropTypes.bool,
      pipeline: PropTypes.bool,
      nominations: PropTypes.bool,
    }),
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  notificationCount: PropTypes.number,
  canSeeAllPages: PropTypes.bool,
  environment: PropTypes.string,
  languageMappings: PropTypes.arrayOf(PropTypes.shape({})),
  containerWidth: PropTypes.number,
};
Header.defaultProps = {
  notificationCount: 0,
  userCurrentOrganization: null,
  canSeeAllPages: false,
  canSetup: false,
  windowWidth: 0,
  containerWidth: 0,
  environment: null,
  languageMappings: [],
};
Header.contextTypes = {
  router: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(Header));
